import serves from './axios'
import qs from 'qs'

const defaultAxios = serves(process.env.VUE_APP_URL)
const mroAxios = serves(process.env.NODE_ENV == ''? 'https://c-brain-t.chint.com/mro-gw/mro/':'https://mro-gw.zhidiancloud.com/mro/')

// 获取登录验证码
export const getCodeImg = (body) => defaultAxios.get('code', body)
// 登录获取token
export const login = (body) => defaultAxios.post('auth/restful/printerLoginForCode', body)
// 刷新token
export const refreshToken = (body) => defaultAxios.post('auth/refresh', body)
// 用户登出
export const logout = (body) => defaultAxios.delete('auth/logout', body)
// 根据token获取用户信息
export const getUserInfo = (body) => defaultAxios.get('system/user/getInfoByBarcodeWeb', body)
// 获取用户路由信息
export const getUserRouters = (body) => defaultAxios.get('system/menu/getRouters?' + qs.stringify(body))
// 获取用户等级列表
export const getLevelList = (body) => defaultAxios.get('mall/levelManage/list' + qs.stringify(body))

// 获取用户路由信息
export const findByCustomerCoding = (body) => defaultAxios.get('system/tenantManagement/findByCustomerCoding/' + body)

// 首页
//#region
// 获取今日条码数据
export const getTodayData = (body) => defaultAxios.get('barcodeweb/search/barcodeNumber', body)
// 获取当月库存数
export const getInventoryOfMonth = (body) => defaultAxios.get('barcodeweb/search/inventoryNumber', body)
// 获取当月出库数
export const getDeliveryOfMonth = (body) => defaultAxios.get('barcodeweb/search/deliveryNumber', body)
// 获取推荐商品
export const getRecommendList = (body) => defaultAxios.get('mall/home/recommend/commodity?' + qs.stringify(body))
//#endregion

// 条码生成
//#region
// 通过客户编码查询订单
export const getSendOrderList = (body) => defaultAxios.get('barcodeweb/order/deList?' + qs.stringify(body))
export const getSendOrderList2 = (body) => defaultAxios.post('barcodeweb/search/shipmentNumberListPost', body)
// 根据发货单查询生产条码信息
export const getGenerateListBySendOrder = (body) => defaultAxios.get('barcodeweb/gen/getMaterial/' + body)
// new 根据发货单查询生产条码信息，带档位
export const getGenerateSendOrderWidthWerks = (body) => defaultAxios.post('barcodeweb/gen/getMaterialByWork', body)
// 获取发货单总已生成数量
export const getAlreadGenCount = (body) => defaultAxios.get('barcodeweb/gen/getAlreadyGenCount?' + qs.stringify(body))

// 条码生成
export const irregularGen = (body) => defaultAxios.post('barcodeweb/gen/irregular', body)
export const setProGenOrder = (body) => defaultAxios.post('barcodeweb/gen', body)
export const testWmsApi = (body) => defaultAxios.post("wms-admin/restful/wmsBarCode/checkBillNoList",body)
//#endregion

// 导入生成
//#region
export const exportDemo = (body) => defaultAxios.post('barcodeweb/gen/irregularExport',body)
export const importExcel = (body) => defaultAxios.post('barcodeweb/gen/irregularImport', body)
export const printByImport = (body) => defaultAxios.post('barcodeweb/gen/irregular',body)
//#endregion

// 条码打印
//#region
// 条码打印搜索
export const getPrintListByType = (body) => defaultAxios.get('barcodeweb/info/search?' + qs.stringify(body))
// 条码包搜索
export const getPrintPackageList = (body) => defaultAxios.get('barcodeweb/info/packSearch?' + qs.stringify(body))
// 根据条码包获取条码信息
export const getPackageInfoByNum = (body,type) => defaultAxios.get(type != null? ('barcodeweb/info/getInfoBySerialNumber/'+body+'?barcodeType='+type):('barcodeweb/info/getInfoBySerialNumber/'+body) )
// export const getPackageInfoByNum = (body,type = 0) => defaultAxios.get('barcodeweb/info/getInfoBySerialNumber/' + type?`${body + '?barcodeType=' + type }`:body  )
// 根据条码包获取条码信息
export const getPackageInfoByParams = (body) => defaultAxios.get('barcodeweb/info/findInfoBySerialNumber?' + qs.stringify(body))
// 批量修改条码状态
export const updatePrintStatus = (body) => defaultAxios.post('barcodeweb/info/status', body)
// 修改条码包状态
export const updatePrintPackage = (body) => defaultAxios.post('info/packNubStatus/', body)
//#endregion

// 物料管理
//#region
// 获取物料
export const getProducts = (body) => defaultAxios.get('barcodeweb/materialMaintenance/list?' + qs.stringify(body))
// 新增物料信息
export const addProduct = (body) => defaultAxios.post('barcodeweb/materialMaintenance', body)
// 修改物料信息
export const editProduct = (body) => defaultAxios.put('barcodeweb/materialMaintenance', body)
// 获取物料属性字典
export const getProSpecList = (body) => defaultAxios.get('system/dict/data/type/barcode_material_spec', body)
// 获取物料属性
export const getProSpecById = (body) => defaultAxios.get('barcodeweb/spec/list?' + qs.stringify(body))
// 修改物料属性
export const saveProductSpec = (body) => defaultAxios.put('barcodeweb/spec', body)
// 删除物料
export const deleteProducts = (body) => defaultAxios.delete('barcodeweb/materialMaintenance/' + body)
// 获取正泰物料
export const getChintProducts = (body) => defaultAxios.get('barcodeweb/materialMaintenance/importBaseMaterial?' + qs.stringify(body))
// 获取MPN物料描述by物料图号
export const getMpnListByMatnr = (body) => defaultAxios.get('barcodeweb/mpnInfo/' + body)
// 新增MPN关联关系
export const setMpnRelation = (body) => defaultAxios.post('barcodeweb/mpnInfo',body)
//#endregion

// 设置
//#region
// 获取我的设置
export const getConfig = (body) => defaultAxios.get('barcodeweb/config/info', body)
// 修改设置
export const setConfigChange = (body) => defaultAxios.put('barcodeweb/config', body)
// 获取模版列表
export const getTemplateList = (body) => defaultAxios.get('barcodeweb/template/list?' + qs.stringify(body))
// 根据模版下载导入模版
export const getExportByTemplate = (body) => defaultAxios.get('barcodeweb/template/download', body)
// 根据模版下载导入
export const importByTemplate = (body) => defaultAxios.post('barcodeweb/gen/irregularImport',body)
// 导入条码数据
export const importByGenBarcode = (body) => defaultAxios.post('barcodeweb/info/import',body)
// 按列表导入条码数据
export const importForList = (body) => defaultAxios.post('barcodeweb/info/importForList',body)
// 新增模版
export const addTemplate = (body) => defaultAxios.post('barcodeweb/template', body)
// 修改模版
export const editTemplate = (body) => defaultAxios.put('barcodeweb/template', body)
// 查看模板
export const getTempById = (body) => defaultAxios.get('barcodeweb/template/' + body)
// 更新模板
export const updateTemp = (body) => defaultAxios.put('/barcodeweb/template', body)
// 删除模板
export const delTempById = (body) => defaultAxios.delete('barcodeweb/template/' + body)
//#endregion

// 条码规则
//#region
// 获取条码规则列表
export const getRuleList = (body) => defaultAxios.get('barcodeweb/rules/list', body)
// 获取条码规则详情
export const getRuleInfo = (body) => defaultAxios.get('barcodeweb/rules/info/' + body)
// 新增条码规则
export const addRule = (body) => defaultAxios.post('barcodeweb/rules', body)
// 修改条码规则
export const editRule = (body) => defaultAxios.put('barcodeweb/rules', body)
// 删除条码规则
export const delRule = (body) => defaultAxios.delete('barcodeweb/rules/' + body)
//#endregion

// 系统
//#region
// 获取租户到期时间
export const getExpiryTime = (body) => defaultAxios.get('/barcodeweb/search/expiryTime', body,"test")
// 获取切换帐号列表
export const getParterList = (body) => defaultAxios.get('/barcodeweb/account/list', body)
// 根据id切换账号
export const changeUserById = (body) => defaultAxios.get('/barcodeweb/account/' + body)
// 获取供方在线sessionId
export const chintCbpLogin = (body) => defaultAxios.get('/system/user/chintSessions?' + qs.stringify(body))
//#endregion

// 云商
//#region
// 获取云商推荐商品
export const getRecommendProduct = (body) => mroAxios.get('pushModule/restful/productList?' + qs.stringify(body))
//#endregion

// 我的条码
//#region
// 按条码编码查询
export const searchByBarcode = (body) => defaultAxios.get('barcodeweb/search/byBarcode?' + qs.stringify(body))
// 按发货单号查询
// export const searchByShipmentNumber = (body) => defaultAxios.get('barcodeweb/search/byShipmentNumber?' + qs.stringify(body))
// 按发货单号查询
export const searchByShipmentNumber = (body) => defaultAxios.get('barcodeweb/search/Invoice?' + qs.stringify(body))
// 发货单查询
export const getShipmentNumberByState = (body) => defaultAxios.get('barcodeweb/search/getShipmentNumber?' + qs.stringify(body))
// 发货单查询
export const getShipmentNumberByCoding = (body) => defaultAxios.get('barcodeweb/noark/getShipmentNumber?' + qs.stringify(body))
// 根据发货单获取发货单详细信息
export const getInfoByShipmentNumber = (body) => defaultAxios.get('barcodeweb/noark/getCustomerAndwerks?' + qs.stringify(body))

export const getBroderByShipmentNumber = (body) => defaultAxios.get('barcodeweb/noark/getBroderByShipmentNumber?' + qs.stringify(body))
// 根据供方编号获取供方名称
export const getSupplierNameByCode = (body) => defaultAxios.get('barcodeweb/customer/list?' + qs.stringify(body))
// 根据供方编号获取供方列表
export const getSupplierListById = (body) => defaultAxios.get('barcodeweb/customer/listByUserId?' + qs.stringify(body))
// 获取上次同步时间
export const getSyncTimeByUser = (body) => defaultAxios.get('barcodeweb/customer/infoByUserId?' + qs.stringify(body))
// 一键同步发货订单
export const syncSupplierOrder = (body) => defaultAxios.post('barcodeweb/noark/syncShipmentNumber', body)
// 内部发货单查询
export const getInternalOrderByshipmentNumber = (body) => defaultAxios.get('barcodeweb/internalSingle/' + body)
// 根据内部发货单号查看详情
export const getInternalOrderDetail = (body) => defaultAxios.get('barcodeweb/internalSingle/getMatnr/' + body)
// 内部发货单同步
export const asyncInternalOrder = (body) => defaultAxios.get('barcodeweb/internalSingle/sync/' + body)

// 通过发货单号同步条码
export const searchSynchronizeOrder = (body) => defaultAxios.get('barcodeweb/gen/synchronizeOrder/' + body)
// 查询发货单
export const searchShipList = (body) => defaultAxios.get('barcodeweb/order/deList?' + qs.stringify(body))
// 查询订单下的物料信息
export const searchOrderMaterial = (body) => defaultAxios.get('barcodeweb/gen/getMaterial/' + body)
// 查询没有发货单号的物料对应条码
export const searchNubNoShip = (body) => defaultAxios.get('barcodeweb/search/NubNoShip?' + qs.stringify(body))
// 查询已生成的条码的数量
export const getAlreadyGenCount = (body) => defaultAxios.get('barcodeweb/gen/getAlreadyGenCount?' + qs.stringify(body))
// 关联发货单号
export const relevanceShipmentNumber = (body) => defaultAxios.post('barcodeweb/info/relevanceShipmentNumber', body)

// 校验条码信息
export const checkQrCodeByScan = (body) => defaultAxios.get('barcodeweb/info/checkQr?' + qs.stringify(body))

// 删除条码
export const deleteBarcode = (body) => defaultAxios.post('barcodeweb/search/deleteBarcode', body)
//#endregion

// 个人中心
//#region
// 查询条码版本信息
export const getVersionList = (body) => defaultAxios.get('mall/renew/barcode?' + qs.stringify(body))

// 条码续费
export const barcodeRenew = (body) => defaultAxios.post('mall/renew/increase', body)

// 获取升级的价钱
export const getUpgradePrice = (body) => defaultAxios.post('mall/renew/product/promote', body)

// 获取购买记录
export const getBuyHistory = (body) => defaultAxios.get('mall/user/order/list?' + qs.stringify(body))

// 生成续费订单
export const renewOrder = (body) => defaultAxios.post('mall/renew/increase', body)

// 生成升档订单
export const upgradeOrder = (body) => defaultAxios.post('mall/renew/product/promoteCreate', body)

//获取支付对公账号
export const getPublicAccount = (id) => defaultAxios.get(`/mall/user/order/getPayNumber/${id}`)

//微信支付是否成功
export const wxPaySuccess = (id) => defaultAxios.get(`/mall/user/order/checkpay/${id}`)

//获取抬头列表
export const getMallInvoice = (body) => defaultAxios.get('/mall/mallInvoice/list?' + qs.stringify(body))

// 获取发票详细信息
export const getMallInvoiceInfo = (body) => defaultAxios.get('/mall/mallInvoice/' + body )

// 新增发票
export const newMallInvoice = (body) => defaultAxios.post('/mall/mallInvoice', body)

// 修改发票
export const updataMallInvoice = (body) => defaultAxios.put('/mall/mallInvoice', body)

// 删除发票
export const delMallInvoice = (body) => defaultAxios.delete('/mall/mallInvoice/' + body)

// 取消订单
export const cancelOrder = (body) => defaultAxios.get('/mall/user/order/cancelOrder/' + body)

// 删除订单
export const delOrder = (body) => defaultAxios.delete('/mall/user/order/deleteOrder/' + body)

// 再次支付
export const reypayOrder = (body) => defaultAxios.get('/mall/renew/reypay/' + body)
//#endregion

// 获取下级供方列表
export const getMySupplierList = (body) => defaultAxios.get('barcodeweb/supplier/list?' + qs.stringify(body))

// 获取上级供方列表
export const getParentSupplier = (body) => defaultAxios.get('barcodeweb/supplier/mfglist?' + qs.stringify(body))

// 发货单分配
export const addSupplierOrder = (body) => defaultAxios.post('barcodeweb/barcodeDispenseShipment', body)

// 供方获取分配发货单号
export const listSupplierList = (body) => defaultAxios.get('barcodeweb/barcodeDispenseShipment/list?' + qs.stringify(body))

// 获取已分配发货单
export const listMySupplierOrder = (body) => defaultAxios.get('barcodeweb/barcodeDispenseShipment/assigned/list?' + qs.stringify(body))

// 删除已分配发货单
export const delMySupplierOrder = (body) => defaultAxios.delete('barcodeweb/barcodeDispenseShipment/' + body)

// 已分配发货单详情
export const infoMySupplierOrder = (body) => defaultAxios.get('barcodeweb/barcodeDispenseShipment/' + body)

// 第三方接口写入条码数据
export const importBmsInfoByOther = (body) => defaultAxios.post('barcodeweb/out/externalGen',body)

// 问题反馈
export const qaAdd = (body) => defaultAxios.post('system/userInquiry/barcodeAdd',body)

// 云商
//#region
const mroAxiosApi = serves(process.env.VUE_APP_MRO_API)

// 获取活动列表
export const getPortalActivityList = () => mroAxiosApi.get('/mro/promoActivity/restful/portalActivityList')

// 获取活动列表
export const getActivityDetail = (id) => mroAxiosApi.get('/mro/promoActivity/restful/'+id)
//#endregion